import script from "./BaseClassItem.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseClassItem.vue?vue&type=script&setup=true&lang=js"

import "./BaseClassItem.vue?vue&type=style&index=0&id=1ef38542&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef38542"]])

export default __exports__